export function getUrl(categ, page, filterQuery, seo) {
  const query = [];

  if (page !== 1) {
    query.push(`page=${page}`);
  }

  if (filterQuery) {
    query.push(`filter=${filterQuery}`);
  }

  const queryString = query.join('&');

  if (!seo && categ.groupIdentifier) {
    return `/categ?id=${categ.groupIdentifier}${queryString ? `&${queryString}` : ''}`;
  }

  const keyword = categ.urlKeyword;
  return queryString && keyword ? `${keyword}${keyword.includes('?') ? '&' : '?'}${queryString}` : keyword;
}

export function createPagination(currentPage, pageNb) {
  if (isNaN(pageNb)) {
    pageNb = 1;
  }

  if (isNaN(currentPage)) {
    currentPage = 1;
  }

  if (pageNb < 0 || currentPage <= 0 || currentPage > pageNb) {
    console.warn('Error: wrong parameter in paginationUtils.createPagination()');
    return;
  }

  let pages;

  if (pageNb <= 10) {
    pages = [...Array.from(Array(pageNb).keys())].map((i) => i + 1);
  } else {
    const [middleStartPage, middleEndPage] = getMiddlePages(currentPage, pageNb);
    pages = [...Array.from(Array((middleEndPage + 1) - middleStartPage).keys())].map((i) => middleStartPage + i);

    const infTens = getInfTens(middleStartPage, currentPage);
    const suppTens = getSuppTens(middleEndPage, currentPage, pageNb);

    pages = infTens.concat(pages).concat(suppTens);
    pages = addDots(pages);
  }

  return pages;
}

/*
  Compute the first and the last page in the middle of the pagination
*/
function getMiddlePages(currentPage, pageNb) {
  let [middleStartPage, middleEndPage] = [0, 0];
  if (pageNb < 6) {
    middleStartPage = 1;
    middleEndPage = pageNb;
  } else if (currentPage < 7) {
    middleStartPage = 1;
    middleEndPage = currentPage + 5;
  } else if (currentPage + 5 >= pageNb) {
    middleStartPage = currentPage - 5;
    middleEndPage = pageNb;
  } else {
    middleStartPage = currentPage - 1;
    middleEndPage = currentPage + 5;
  }
  return [middleStartPage, middleEndPage];
}

/*
  Compute the left side of the pagination
*/
function getInfTens(middleStartPage, currentPage) {
  const infTens = [];
  let ten = 10 * Math.floor(currentPage / 10);

  for (let i = 0; ten > 0 && i < 3; i++) {
    if (ten < middleStartPage) {
      infTens.push(ten);
    } else {
      i--;
    }
    ten -= 10;
  }

  if (middleStartPage > 1) {
    infTens.push(1);
  }

  return infTens.reverse();
}

/*
  Compute the right side of the pagination
*/
function getSuppTens(middleEndPage, currentPage, pageNb) {
  const suppTens = [];
  let ten = 10 * Math.floor(currentPage / 10 + 1);

  for (let i = 0; ten < pageNb && i < 3; i++) {
    if (ten > middleEndPage) {
      suppTens.push(ten);
    } else {
      i--;
    }
    ten += 10;
  }

  if (middleEndPage < pageNb) {
    suppTens.push(pageNb);
  }

  return suppTens;
}

/*
  add '...' on the pagination
*/
function addDots(pages) {
  for (let i = pages.length - 1; i > 0; i--) {
    const isNotSuccessive = (pages[i] - 1) !== pages[i - 1];
    const isNotTenDifference = (pages[i] - 10) !== pages[i - 1];
    const isTenSupp = (pages[i - 1] === pages[i] - 1) && (pages[i + 1] === (pages[i] + 10));
    const isTenInf = (pages[i - 1] === pages[i] - 10) && (pages[i + 1] === (pages[i] + 1));

    if (isNotSuccessive && isNotTenDifference) {
      pages.splice(i, 0, '...');
    }
    if (isTenInf) {
      pages.splice(i, 0, '...');
    }
    if (isTenSupp) {
      pages.splice(i + 1, 0, '...');
    }
  }

  return pages;
}
